<template>
    <b-modal id="edit-modal" title="Edit News" size="lg">
        <b-row>
            <b-col>
                <div id="edit-news" class="modal-form">
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Title</h6>
                        </b-col>
                        <b-col>
                            <b-form-group id="newsTitleGroup"
                                          label="News Title"
                                          label-for="newsTitle" class="secondary-label"
                                          :invalid-feedback="errorMessage('title')"
                                          :state="isValid('title')">
                                <b-form-input id="newsTitle"
                                              type="text"
                                              v-model="form.title"
                                              maxlength="30"
                                              required>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Image</h6>
                            <span class="label-helper d-inline-block">(350 x 200)</span>
                        </b-col>
                        <b-col>
                            <div id="news-upload-image" class="border" v-b-modal.newsUploadImage>
                                <!-- Use an if else here for showing an image -->
                                <!-- <img src="../../assets/images/sample-badge.png" alt="Sample Badge"> -->
                                <img v-if="image === ''" :src="form.image" alt="Sample Badge">
                                <img v-else :src="image" alt="Sample Badge">
                                <div class="upload-icon rounded-circle border">
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Details<i id="content-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="content-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <!--<b-form-group id="subjectGroup"-->
                                          <!--label="Subject"-->
                                          <!--label-for="subject" class="secondary-label">-->
                                <!--<b-form-input id="subject"-->
                                              <!--type="text"-->
                                              <!--v-model="form.subject"-->
                                              <!--required>-->
                                <!--</b-form-input>-->
                            <!--</b-form-group>-->
                            <b-form-group id="messageGroup"
                                          label-for="message" class="secondary-label"
                                          :invalid-feedback="errorMessage('details')"
                                          :state="isValid('details')">
                                <vue-editor id="message" v-model="form.details" required :editorToolbar="customToolbar"></vue-editor>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Publish Date<i id="schedule-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="schedule-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <b-row no-gutters>
                                <b-col cols="5">
                                    <b-form-group class="mb-1" :invalid-feedback="errorMessage('publish_date')"
                                                  :state="isValid('publish_date')">
                                        <label class="secondary-label align-top">Date</label>
                                        <div class="custom-datepicker mb-3 muli-sb">
                                            <SingleDatepicker :bootstrap-styling="true"
                                                              :value="form.publish_date"
                                                              ref="publishProgramaticOpen"
                                                              v-model="form.publish_date"
                                                              wrapper-class="custom-datepicker"
                                                              style="color: #2a2a2a !important;"
                                            >
                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                        <span class="input-group-text">
                                                            <img @click="openPublishPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                        </span>
                                                </div>
                                            </SingleDatepicker>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <div id="custom-timepicker" style="width: 164px;">
                                        <b-form-group class="ml-3">
                                            <label class="secondary-label align-top">Time</label>
                                            <b-input-group>
                                                <b-input-group-text slot="append">
                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                </b-input-group-text>
                                                <vue-timepicker v-model="publishTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>

                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Validity<i id="schedule-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="schedule-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <b-row no-gutters>
                                <b-col cols="5">
                                    <b-form-group class="mb-1"  :invalid-feedback="errorMessage('validity')"
                                                  :state="isValid('validity')">
                                        <label class="secondary-label align-top">Date</label>
                                        <div class="custom-datepicker mb-3 muli-sb">
                                            <SingleDatepicker :bootstrap-styling="true"
                                                              :value="form.validity"
                                                              ref="validityProgramaticOpen"
                                                              v-model="form.validity"
                                                              wrapper-class="custom-datepicker"
                                                              style="color: #2a2a2a !important;"
                                            >
                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                        <span class="input-group-text">
                                                            <img @click="openValidityPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                        </span>
                                                </div>
                                            </SingleDatepicker>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <div id="custom-timepicker" style="width: 164px;">
                                        <b-form-group class="ml-3">
                                            <label class="secondary-label align-top">Time</label>
                                            <b-input-group>
                                                <b-input-group-text slot="append">
                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                </b-input-group-text>
                                                <vue-timepicker v-model="validityTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Button Link</h6>
                        </b-col>
                        <b-col>
                            <div>
                                <switches :value="true"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;"
                                          v-if="form.button_name != null && form.button_name != ''">
                                </switches>
                                <switches :value="false"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;"
                                          v-else>
                                </switches>
                                <div style="margin-top: -12px;">
                                    <b-form-group id="buttonTitleGroup"
                                                  label="Button Title"
                                                  label-for="buttonTitle" class="secondary-label"
                                                  :invalid-feedback="errorMessage('button_name')"
                                                  :state="isValid('button_name')">
                                        <b-form-input id="buttonTitle"
                                                      type="text"
                                                      v-model="form.button_name"
                                                      required
                                                      maxlength="20">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="urlLinkGroup"
                                                  label="URL Link"
                                                  label-for="urlLink" class="secondary-label"
                                                  :invalid-feedback="errorMessage('url')"
                                                  :state="isValid('url')">
                                        <b-form-input id="urlLink"
                                                      type="text"
                                                      value=""
                                                      :disabled="true"
                                                      v-if="form.button_name == null || form.button_name === ''"
                                                      required
                                                      maxlength="5000">
                                        </b-form-input>
                                        <b-form-input id="urlLink"
                                                      type="text"
                                                      v-model="form.url"
                                                      :disabled="false"
                                                      v-else
                                                      required
                                                      maxlength="5000">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Visibility<i id="visibility-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="visibility-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="d-block mb-3 secondary-label">Publish in App</span>
                                <switches v-model="form.is_enabled"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;" :disabled="form.is_draft">
                                </switches>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Draft<i id="visibility-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="visibility-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="d-block mb-3 secondary-label">Draft News</span>
                                <switches v-model="form.is_draft"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;">
                                </switches>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-btn variant="ghost" v-bind:disabled="loading" class="mr-1 btn-cancel" @click="clearFields">
                Cancel
            </b-btn>
            <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="sendForm">
                <template v-if="loading">
                    Updating...
                </template>
                <template v-else>
                    Update
                </template>
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Switches from "vue-switches";
import EngagementNav from "./EngagementNav.vue";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { mapState } from "vuex";

function initialState() {
    return {
        croppa: {},
        sliderVal: 0,
        sliderMin: 0,
        sliderMax: 0,
        urlInput: true,
        disabledDates: {
            to: new Date(Date.now() - 8640000)
        },
        customToolbar: [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ["bold", "italic", "underline"],
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }]
        ]
    };
}
export default {
    name: "news",
    props: ["image", "form"],
    data() {
        return initialState();
    },
    components: {
        EngagementNav,
        Switches,
        Datepicker,
        VueEditor,
        SingleDatepicker,
        VueTimepicker
    },
    computed: {
        ...mapState("news", ["errors", "currentPage", "loading"]),
        validityTime: {
            get: function() {
                let momentTime = this.$moment(this.form.validity);

                return {
                    HH: momentTime.format("HH"),
                    mm: momentTime.format("mm"),
                    ss: momentTime.format("ss")
                };
            },
            set: function(value) {
                this.validityTime.HH = value.HH;
                this.validityTime.mm = value.mm;
                this.validityTime.ss = value.ss;
            }
        },
        publishTime: {
            get: function() {
                let momentTime = this.$moment(this.form.publish_date);

                return {
                    HH: momentTime.format("HH"),
                    mm: momentTime.format("mm"),
                    ss: momentTime.format("ss")
                };
            },
            set: function(value) {
                this.publishTime.HH = value.HH;
                this.publishTime.mm = value.mm;
                this.publishTime.ss = value.ss;
            }
        }
    },
    methods: {
        async sendForm() {
            this.$store.dispatch("news/resetErrors");

            let param = {
                title: this.form.title,
                details: this.form.details,
                is_draft: this.form.is_draft,
                // is_enabled: this.form.is_enabled,
                sequence: null,
                publish_date: this.formatDate(
                    this.form.publish_date,
                    this.publishTime
                )
            };

            if (this.image != "")
                param.image = this.image.replace(
                    /^data:image\/\w+;base64,/,
                    ""
                );

            if (this.form.validity !== undefined) {
                param.validity = this.formatDate(
                    this.form.validity,
                    this.validityTime
                );
            }

            if (this.form.button_name != null) {
                param.url = this.form.url;
                param.button_name = this.form.button_name;
            }

            if (!this.form.is_draft) {
                param.is_enabled = this.form.is_enabled;
            } else {
                param.is_enabled = false;
            }

            let data = {
                param: param,
                uuid: this.form.uuid
            };

            let _this = this;
            await this.$store
                .dispatch("news/updateNews", data)
                .then(function() {
                    if (_this.errors == null) {
                        _this.hideModal("edit-modal");
                        _this.getNews(_this.currentPage);
                    }
                });
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        formatDate(date, time) {
            let h = time.HH;
            let m = time.mm;
            let s = time.ss;

            let t = h + ":" + m + ":" + s;

            let d = this.$moment(date).format("YYYY-MM-DD");

            let datetime = d + " " + t;

            return datetime;
        },
        clearFields() {
            let initialData = initialState();

            // Iterate through the props
            for (let prop in initialData) {
                // Reset the prop locally.
                this[prop] = initialData[prop];
            }

            this.hideModal("edit-modal");
            this.$store.dispatch("news/resetErrors");
            this.$store.dispatch("news/resetEditing");
        },
        async getNews(page) {
            await this.$store.dispatch("news/getNews", page);
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);
        },
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        openPublishPicker() {
            this.$refs.publishProgramaticOpen.showCalendar();
        },
        openValidityPicker() {
            this.$refs.validityProgramaticOpen.showCalendar();
        },
        enableUrl(value) {
            this.urlInput = value;
        }
    }
};
</script>
